import { Trans, useTranslation } from "react-i18next";

const externalLinkClass = "underline underline-offset-2 hover:opacity-80";

const linkResults = (
  // biome-ignore lint/a11y/useAnchorContent: content provided by Trans i18n component
  <a
    href="https://upacjenta.pl/zlecenie/autoryzacja/logowanie"
    target="_blank"
    rel="noreferrer"
    className={externalLinkClass}
  />
);

export const BasicContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <p className="font-semibold">{t("VOUCHERS_DISTRIBUTION.TERMS_AGREEMENT.CONTENT.HEADING")}</p>
      <ol className="mt-3 list-decimal space-y-3 pl-5">
        <li>{t("VOUCHERS_DISTRIBUTION.TERMS_AGREEMENT.CONTENT.BASIC.ITEM_1")}</li>
        <li>{t("VOUCHERS_DISTRIBUTION.TERMS_AGREEMENT.CONTENT.BASIC.ITEM_2")}</li>
        <li>{t("VOUCHERS_DISTRIBUTION.TERMS_AGREEMENT.CONTENT.BASIC.ITEM_3")}</li>
        <li>
          <Trans i18nKey="VOUCHERS_DISTRIBUTION.TERMS_AGREEMENT.CONTENT.BASIC.ITEM_4" components={{ linkResults }} />
        </li>
      </ol>
    </>
  );
};

export const FriendsAndFamilyContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <p className="font-semibold">{t("VOUCHERS_DISTRIBUTION.TERMS_AGREEMENT.CONTENT.HEADING")}</p>
      <ol className="mt-3 list-decimal space-y-3 pl-5">
        <li>
          <p>{t("VOUCHERS_DISTRIBUTION.TERMS_AGREEMENT.CONTENT.FRIENDS_AND_FAMILY.ITEM_1_PARAGRAPH_1")}</p>
          <p className="mt-3">
            {t("VOUCHERS_DISTRIBUTION.TERMS_AGREEMENT.CONTENT.FRIENDS_AND_FAMILY.ITEM_1_PARAGRAPH_2")}
          </p>
        </li>
        <li>
          <Trans
            i18nKey="VOUCHERS_DISTRIBUTION.TERMS_AGREEMENT.CONTENT.FRIENDS_AND_FAMILY.ITEM_2"
            components={{ linkResults }}
          />
        </li>
      </ol>
    </>
  );
};
